import { UIIconProps } from "./props"
import { icons } from "../../assets/icons"

const UIIcon = ({ iconName, color, size, ...rest }: UIIconProps) => {
  const Icon = icons[iconName as keyof typeof icons]
  const iconColor = color || "inherit"
  const iconSize = size || 24

  return (
    <Icon
      style={{ flexShrink: 0, color: iconColor }}
      stroke={iconColor}
      width={iconSize}
      height={iconSize}
      {...rest}
    />
  )
}

export default UIIcon
